import { createReducer, createAction } from '@reduxjs/toolkit';

import { backendCall, createApiCall } from '@reducers/utils';
import type { AppDispatch } from '@store/types';
import type {
  AdminState,
  ApplyPartMasterDataChangesRequestDto,
  ApplyNcFileVersionMasterDataChangesRequestDto,
  ApplyPartMasterDataChangesResponse,
  ApplyNcFileVersionMasterDataChangesResponse,
} from './types';

// Re-export types for consumers
export type {
  AdminState,
  ApplyPartMasterDataChangesRequestDto,
  ApplyNcFileVersionMasterDataChangesRequestDto,
  ApplyPartMasterDataChangesResponse,
  ApplyNcFileVersionMasterDataChangesResponse,
} from './types';

// === Initial State ===

const initState: AdminState = {};

// === Selectors ===

// No meaningful selectors for this reducer

// === Actions ===

export const clear = createAction('clear');
export const close = createAction('admin/close');

// === Thunks ===

export const applyPartMasterDataChanges =
  (data: ApplyPartMasterDataChangesRequestDto) =>
  async (dispatch: AppDispatch): Promise<ApplyPartMasterDataChangesResponse | undefined> => {
    return await dispatch(
      backendCall(
        createApiCall((api) => api.admin.applyPartMasterDataChanges, {
          params: data,
        })
      )
    );
  };

export const applyNcFileVersionMasterDataChanges =
  (data: ApplyNcFileVersionMasterDataChangesRequestDto) =>
  async (dispatch: AppDispatch): Promise<ApplyNcFileVersionMasterDataChangesResponse | undefined> => {
    return await dispatch(
      backendCall(
        createApiCall((api) => api.admin.applyNcFileVersionMasterDataChanges, {
          params: data,
        })
      )
    );
  };

// === Reducer ===

export default createReducer<AdminState>(initState, (builder) => {
  builder
    .addCase(clear, () => initState)
    .addCase(close, () => initState);
});
